/**
 * The arena countdown leaf (unit convention §1). It takes ONE prop rather than
 * zero because `paused` is already on the card's own subscription: reading the
 * arena status a second time here would double the card's store reads to save
 * nothing.
 */
import React from 'react';

import {useNextPairingModel} from './NextPairing.model';
import NextPairingView from './NextPairing.View';

export default React.memo(function NextPairing({paused}: {paused: boolean}) {
  return <NextPairingView {...useNextPairingModel(paused)} />;
});
